import React from "react";
import { useParams } from "react-router-dom";
import VehicleDetail from "@/pages/VehicleDetail";
import ZoneLanding, { ZONE_SLUGS } from "@/pages/ZoneLanding";

/**
 * Slug router for /cars/:slug · /es/coches/:slug · /ru/cars/:slug.
 * Zone landing pages (luxury-car-rental-<zone>) share the same URL pattern as
 * individual vehicle pages, so we dispatch here based on the slug shape.
 */
export default function CarSlugRouter() {
  const { slug } = useParams();
  if (ZONE_SLUGS.includes(slug)) return <ZoneLanding />;
  return <VehicleDetail />;
}
